import script from "./PCNotice.vue?vue&type=script&lang=ts&setup=true"
export * from "./PCNotice.vue?vue&type=script&lang=ts&setup=true"

import "./PCNotice.vue?vue&type=style&index=0&id=9af37c70&lang=scss&scoped=true"

import exportComponent from "/data/code/front/deli-front-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9af37c70"]])

export default __exports__